const firebaseConfig = {
    apiKey: "AIzaSyC6NiDF3e5qQkjVFrn0suT7Nugn7xoWxfo",
    authDomain: "aj-riders.firebaseapp.com",
    projectId: "aj-riders",
    storageBucket: "aj-riders.appspot.com",
    messagingSenderId: "348336159225",
    appId: "1:348336159225:web:9d5156ddba37f77c6c2528"
  };

export default firebaseConfig;